module.exports = __webpack_public_path__ + "static/img/t10.4037aebd.png";